import 'angular:locale/data:uk';
import 'angular:locale/data:tr';
import 'angular:locale/data:es';
import 'angular:locale/data:en';
import 'angular:locale/data:de';
import './projects/club-member-app/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
